
import { useState } from 'react';
import { Region } from '../data/types/region-types';
import { City } from '../data/types/city-types';
import { regions_mexico } from '../data/regions';
import { chiapas_cities, getCityById as getChiapasCityById } from '../data/chiapas/cities-data';
import { hidalgo_cities, getCityById as getHidalgoCityById } from '../data/hidalgo/cities-data';

export function useRegionCityState() {
  const [selectedRegion, setSelectedRegion] = useState<Region | null>(null);
  const [selectedCity, setSelectedCity] = useState<City | null>(null);
  const [isChiapasActive, setIsChiapasActive] = useState(false);
  const [isHidalgoActive, setIsHidalgoActive] = useState(false);
  // Track whether we were in Mexico view before selecting a region
  const [wasInMexicoView, setWasInMexicoView] = useState(true);

  const handleRegionClick = (region: Region) => {
    // Remember we were in Mexico view before selecting a region
    setWasInMexicoView(true);
    setSelectedRegion(region);
    setSelectedCity(null);
    
    setIsChiapasActive(region.region_id === 'CHIS');
    setIsHidalgoActive(region.region_id === 'HGO');
  };

  const handleCityClick = (city: City) => {
    setSelectedCity(city);
  };

  const handleRegionSelect = (region: Region | null) => {
    if (region) {
      // Remember we were in Mexico view before selecting a region
      setWasInMexicoView(true);
    }
    
    setSelectedRegion(region);
    setSelectedCity(null);
    
    if (region) {
      setIsChiapasActive(region.region_id === 'CHIS');
      setIsHidalgoActive(region.region_id === 'HGO');
    } else {
      setIsChiapasActive(false);
      setIsHidalgoActive(false);
    }
  };

  const handleCitySelect = (cityId: string) => {
    let city = getChiapasCityById(cityId);
    
    if (!city) {
      city = getHidalgoCityById(cityId);
    }
    
    if (city) {
      if (selectedRegion?.region_id !== city.region_id) {
        const cityRegion = regions_mexico.find(r => r.region_id === city.region_id);
        if (cityRegion) {
          // Remember we were in Mexico view before selecting this city's region
          setWasInMexicoView(true);
          
          setSelectedRegion(cityRegion);
          setIsChiapasActive(cityRegion.region_id === 'CHIS');
          setIsHidalgoActive(cityRegion.region_id === 'HGO');
        }
      }
      setSelectedCity(city);
    }
  };

  const handleGoBack = () => {
    if (selectedCity) {
      // If we're viewing a city, go back to the region view
      setSelectedCity(null);
    } else if (selectedRegion) {
      // If we're viewing a region, go back to the Mexico view (not world view)
      setSelectedRegion(null);
      setIsChiapasActive(false);
      setIsHidalgoActive(false);
      // Signal that we want to return to Mexico view, not world view
      setWasInMexicoView(true);
    }
  };

  return {
    selectedRegion,
    selectedCity,
    isChiapasActive,
    isHidalgoActive,
    wasInMexicoView,
    handleRegionClick,
    handleCityClick,
    handleRegionSelect,
    handleCitySelect,
    handleGoBack
  };
}
